import type {
  CompanyLink,
  CompanySec,
  Defi,
  Eco,
  Exchange,
  Learn,
  LearnSec,
  Products,
  Section,
} from './types'

export const products_global: Products[] = [
  {
    tTitle: 'products.buyAndSell',
    tDesc: 'products.appDescription',
    href: '/app',
  },
  {
    tTitle: 'products.metalCards',
    tDesc: 'products.metalCardsDescription',
    href: '/cards',
  },
  {
    tTitle: 'products.pay',
    tDesc: 'products.payDescription',
    href: '/pay',
  },
  {
    tTitle: 'products.earn',
    tDesc: 'products.earnDescription',
    href: '/earn',
  },
  {
    tTitle: 'products.credit',
    tDesc: 'products.creditDescription',
    href: '/credit',
  },
]

export const exchange_global: Exchange[] = [
  {
    tTitle: 'products.exchangeIndex',
    tDesc: 'products.exchangeIndexDescription',
    href: 'https://crypto.com/exchange',
  },
  {
    tTitle: 'products.marginTrading',
    tDesc: 'products.marginTradingDescription',
    href: 'https://crypto.com/exchange/trade/BTC_USD',
  },
  {
    tTitle: 'products.derivatives',
    tDesc: 'products.derivativesDescription',
    href: 'https://crypto.com/exchange/trade/BTCUSD-PERP',
  },
]
export const defi_global: Defi[] = [
  {
    tTitle: 'products.defiWallet',
    tDesc: 'products.defiWalletDescription',
    href: '/defi-wallet',
  },
  {
    tTitle: 'products.browserExt',
    tDesc: 'products.browserExtDescription',
    href: '/defi-wallet#wallet_extension',
  },
  {
    tTitle: 'products.desktopWallet',
    tDesc: 'products.desktopWalletDescription',
    href: '/defi-wallet#defi_wallet_desktop',
  },
]

export const eco_global: Eco[] = [
  {
    tTitle: 'products.payMerchant',
    tDesc: 'products.payMerchantDescription',
    href: '/pay-merchant',
  },
]

export const products_desktop_global: Section[] = [
  {
    tTitle: 'products.sectionTitle_getStarted',
    items: [
      {
        tTitle: 'products.categoryTitle_buyAndSell',
        items: [
          {
            tTitle: 'products.app',
            tDesc: 'products.appDescription',
            href: '/app',
          },
          {
            tTitle: 'products.nft',
            tDesc: 'products.nftDescription',
            href: 'https://crypto.com/nft',
          },
        ],
      },
      {
        tTitle: 'products.categoryTitle_spend',
        items: [
          {
            tTitle: 'products.metalCards',
            tDesc: 'products.metalCardsDescription',
            href: '/cards',
          },
          {
            tTitle: 'products.pay',
            tDesc: 'products.payDescription',
            href: '/pay',
          },
        ],
      },
      {
        tTitle: 'products.categoryTitle_grow',
        items: [
          {
            tTitle: 'products.earn',
            tDesc: 'products.earnDescription',
            href: '/earn',
          },
          {
            tTitle: 'products.credit',
            tDesc: 'products.creditDescription',
            href: '/credit',
          },
        ],
      },
    ],
  },
  {
    tTitle: 'products.sectionTitle_advancedTrading',
    items: [
      {
        tTitle: 'products.categoryTitle_exchange',
        items: [
          {
            tTitle: 'products.exchangeIndex',
            tDesc: 'products.exchangeIndexDescription',
            href: 'https://crypto.com/exchange',
          },
          {
            tTitle: 'products.marginTrading',
            tDesc: 'products.marginTradingDescription',
            href: 'https://crypto.com/exchange/trade/BTC_USD',
          },
          {
            tTitle: 'products.derivatives',
            tDesc: 'products.derivativesDescription',
            href: 'https://crypto.com/exchange/trade/BTCUSD-PERP',
          },
        ],
      },
      {
        tTitle: 'products.categoryTitle_defi',
        items: [
          {
            tTitle: 'products.defiWallet',
            tDesc: 'products.defiWalletDescription',
            href: '/defi-wallet',
          },
          {
            tTitle: 'products.browserExt',
            tDesc: 'products.browserExtDescription',
            href: '/defi-wallet#wallet_extension',
          },
          {
            tTitle: 'products.desktopWallet',
            tDesc: 'products.desktopWalletDescription',
            href: '/defi-wallet#defi_wallet_desktop',
          },
        ],
      },
      {
        tTitle: 'products.categoryTitle_ecosystem',
        items: [
          {
            tTitle: 'products.payMerchant',
            tDesc: 'products.payMerchantDescription',
            href: '/pay-merchant',
          },
        ],
      },
    ],
  },
]

export const learn_global: Learn[] = [
  {
    tTitle: 'learn.trending',
    tDesc: 'learn.trendingDescription',
    href: '/trending',
  },
  {
    tTitle: 'learn.marketUpdates',
    tDesc: 'learn.marketUpdatesDescription',
    href: '/market-updates',
  },
  {
    tTitle: 'learn.productNews',
    tDesc: 'learn.productNewsDescription',
    href: '/product-news',
  },
  {
    tTitle: 'learn.events',
    tDesc: 'learn.eventsDescription',
    href: '/events',
  },
  {
    tTitle: 'learn.university',
    tDesc: 'learn.universityDescription',
    href: '/university',
  },
  {
    tTitle: 'learn.reportsAndAnalysis',
    tDesc: 'learn.reportsAndAnalysisDescription',
    href: '/research',
  },
  {
    tTitle: 'learn.nftStories',
    tDesc: 'learn.nftStoriesDescription',
    href: '/nft-stories',
  },
]

export const company_global: CompanyLink[] = [
  {
    tTitle: 'company.about',
    tDesc: 'company.aboutDescription',
    href: '/about',
  },
  {
    tTitle: 'company.careers',
    tDesc: 'company.careersDescription',
    href: '/careers',
  },
  {
    tTitle: 'company.news',
    tDesc: 'company.newsDescription',
    href: 'https://crypto.com/company-news',
  },
  {
    tTitle: 'company.support',
    tDesc: 'company.supportDescription',
    href: 'https://help.crypto.com/en',
  },
  {
    tTitle: 'company.security',
    tDesc: 'company.securityDescription',
    href: '/security',
  },
  {
    tTitle: 'company.partners',
    tDesc: 'company.partnersDescription',
    href: '/partners',
  },
]

export const learn_desktop_global: LearnSec[] = [
  {
    tTitle: 'learn.categoryTitle_updates',
    items: [
      {
        tTitle: 'learn.trending',
        tDesc: 'learn.trendingDescription',
        href: '/trending',
      },
      {
        tTitle: 'learn.events',
        tDesc: 'learn.eventsDescription',
        href: '/events',
      },
      {
        tTitle: 'learn.productNews',
        tDesc: 'learn.productNewsDescription',
        href: '/product-news',
      },
      {
        tTitle: 'learn.marketUpdates',
        tDesc: 'learn.marketUpdatesDescription',
        href: '/market-updates',
      },
    ],
  },
  {
    tTitle: 'learn.categoryTitle_resources',
    items: [
      {
        tTitle: 'learn.university',
        tDesc: 'learn.universityDescription',
        href: '/university',
      },
      {
        tTitle: 'learn.reportsAndAnalysis',
        tDesc: 'learn.reportsAndAnalysisDescription',
        href: '/research',
      },
      {
        tTitle: 'learn.nftStories',
        tDesc: 'learn.nftStoriesDescription',
        href: '/nft-stories',
      },
    ],
  },
]
export const company_desktop_global: CompanySec[] = [
  {
    tTitle: 'company.sectionTitle_aboutUs',
    items: [
      {
        tTitle: 'company.about',
        tDesc: 'company.aboutDescription',
        href: '/about',
      },
      {
        tTitle: 'company.support',
        tDesc: 'company.supportDescription',
        href: 'https://help.crypto.com/en',
      },
      {
        tTitle: 'company.careers',
        tDesc: 'company.careersDescription',
        href: '/careers',
      },
      {
        tTitle: 'company.security',
        tDesc: 'company.securityDescription',
        href: '/security',
      },
      {
        tTitle: 'company.news',
        tDesc: 'company.newsDescription',
        href: 'https://crypto.com/company-news',
      },
      {
        tTitle: 'company.partners',
        tDesc: 'company.partnersDescription',
        href: '/partners',
      },
    ],
  },
]
